/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { LinkItem } from "components/ui/Button";
import Stack from "components/ui/Stack";
import Text from "components/ui/Text";

const ErrorBoundary = () => {
  return (
    <div
      className="flex h-screen items-center justify-center"
      test-id="x6rYMcOv"
    >
      <Stack test-id="37Y8HnHr">
        <div className="mx-auto mb-4 sm:mb-8 px-8" test-id="MqCjiyIH">
          <svg
            width="100%"
            height="143"
            viewBox="0 0 430 143"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            test-id="Y3Gn-7yo"
          >
            <path
              d="M247.228 54.2551C245.98 49.5933 244.118 45.6061 241.622 42.2868C239.18 38.9203 236.137 36.3364 232.494 34.535C228.898 32.7405 224.722 31.8364 219.972 31.8364C215.499 31.8364 211.647 32.8079 208.422 34.7442C206.128 36.1407 204.098 37.9285 202.33 40.1144L201.568 33.2262H179.851V136.853H203.16V101.987C204.739 103.768 206.513 105.265 208.49 106.48C211.715 108.463 215.567 109.455 220.04 109.455C224.789 109.455 228.965 108.511 232.561 106.622C236.204 104.685 239.247 101.987 241.696 98.5257C244.138 95.0715 245.98 91.0101 247.228 86.355C248.476 81.6932 249.097 76.6468 249.097 71.2023V69.7518C249.097 64.078 248.476 58.9102 247.228 54.2551ZM225.781 71.2023C225.781 74.0156 225.599 76.6468 225.228 79.089C224.864 81.5313 224.236 83.6969 223.359 85.5927C222.489 87.4345 221.308 88.8917 219.831 89.9509C218.36 90.9629 216.511 91.4689 214.298 91.4689C210.979 91.4689 208.348 90.7335 206.412 89.256C205.036 88.2103 203.949 86.8677 203.16 85.2418C202.829 84.5739 202.56 83.8655 202.33 83.1032C201.548 80.4248 201.203 77.3349 201.291 73.8335V68.1597C201.251 65.117 201.406 62.4656 201.777 60.2055C202.087 58.4987 202.546 57.0009 203.16 55.7191C203.369 55.2738 203.605 54.8488 203.855 54.4575C204.867 52.8923 206.203 51.7386 207.869 51.0033C209.569 50.2207 211.667 49.8226 214.164 49.8226C216.329 49.8226 218.151 50.3084 219.628 51.2799C221.099 52.2446 222.28 53.6277 223.157 55.429C224.074 57.2303 224.742 59.3487 225.16 61.791C225.579 64.1927 225.781 66.8441 225.781 69.7518V71.2023Z"
              fill="url(#paint0_linear_5100_344724)"
              test-id="7Hs2jopi"
            />

            <path
              d="M226.229 79.2393C226.608 76.74 226.793 74.058 226.793 71.2023V69.7518C226.793 66.799 226.588 64.0886 226.158 61.6187C225.726 59.1016 225.033 56.8852 224.062 54.9777C223.117 53.0381 221.823 51.5097 220.184 50.4343C218.508 49.3321 216.482 48.8107 214.164 48.8107C211.569 48.8107 209.319 49.2232 207.453 50.0807C205.603 50.8986 204.119 52.185 203.005 53.908L203.005 53.908L203.002 53.9132C202.73 54.3391 202.473 54.801 202.246 55.2854C201.585 56.6648 201.104 58.2512 200.781 60.0245L200.78 60.033L200.778 60.0416C200.395 62.3762 200.239 65.0881 200.279 68.1664V73.8209C200.191 77.3954 200.541 80.5892 201.359 83.387L201.359 83.387L201.361 83.3948C201.603 84.1999 201.892 84.9612 202.251 85.6871C203.106 87.4466 204.29 88.9147 205.798 90.0605C207.965 91.7145 210.838 92.4808 214.298 92.4808C216.666 92.4808 218.728 91.9382 220.404 90.7846L220.412 90.7791L220.42 90.7734C222.054 89.6025 223.339 88.0036 224.274 86.025L224.274 86.025L224.277 86.0176C225.201 84.0222 225.852 81.762 226.229 79.2393ZM226.229 79.2393C226.229 79.239 226.229 79.2386 226.229 79.2383L225.228 79.089L226.228 79.241C226.228 79.2405 226.228 79.2399 226.229 79.2393ZM246.251 54.5168L246.251 54.5172C247.472 59.0728 248.085 64.1508 248.085 69.7518V71.2023C248.085 76.5697 247.473 81.527 246.251 86.0929C245.029 90.6494 243.234 94.5982 240.87 97.9415C238.51 101.277 235.587 103.867 232.088 105.727C228.661 107.527 224.652 108.443 220.04 108.443C215.719 108.443 212.058 107.487 209.02 105.618L209.019 105.618C207.13 104.457 205.432 103.024 203.917 101.315L202.148 99.3193V101.987V135.841H180.863V34.2382H200.662L201.324 40.2257L201.591 42.6376L203.117 40.7507C204.814 38.6524 206.756 36.9436 208.946 35.6102C211.986 33.7858 215.65 32.8484 219.972 32.8484C224.592 32.8484 228.609 33.7272 232.042 35.4405L232.045 35.4422C235.538 37.169 238.454 39.6441 240.803 42.881L240.808 42.8881L240.813 42.895C243.219 46.0944 245.03 49.9589 246.251 54.5168Z"
              stroke="url(#paint1_linear_5100_344724)"
              strokeOpacity="0.31"
              strokeWidth="2.02395"
              test-id="6j3Vt3Zq"
            />

            <path
              d="M88.2022 55.7068V59.7884C88.2022 67.4902 87.1185 74.408 84.9509 80.5418C82.8294 86.6295 79.8086 91.8409 75.8885 96.1761C71.9684 100.465 67.3335 103.763 61.9837 106.069C56.634 108.328 50.7308 109.458 44.2741 109.458C37.7714 109.458 31.8221 108.328 26.4262 106.069C21.0764 103.763 16.4184 100.465 12.4522 96.1761C8.5321 91.8409 5.48826 86.6295 3.32068 80.5418C1.19922 74.408 0.138489 67.4902 0.138489 59.7884V55.7068C0.138489 48.005 1.19922 41.0872 3.32068 34.9534C5.48826 28.8196 8.50904 23.6082 12.383 19.3192C16.3031 14.984 20.938 11.6865 26.2878 9.42668C31.6837 7.12074 37.633 5.96777 44.1358 5.96777C50.5924 5.96777 56.4956 7.12074 61.8454 9.42668C67.2413 11.6865 71.8993 14.984 75.8194 19.3192C79.7395 23.6082 82.7833 28.8196 84.9509 34.9534C87.1185 41.0872 88.2022 48.005 88.2022 55.7068ZM63.5748 59.7884V55.5685C63.5748 50.5877 63.1367 46.2064 62.2604 42.4246C61.4303 38.5968 60.1851 35.3915 58.5248 32.8089C56.8646 30.2262 54.8123 28.2892 52.368 26.9979C49.9698 25.6605 47.2257 24.9918 44.1358 24.9918C40.9075 24.9918 38.0942 25.6605 35.696 26.9979C33.2979 28.2892 31.2917 30.2262 29.6775 32.8089C28.0634 35.3915 26.8412 38.5968 26.0111 42.4246C25.2271 46.2064 24.8351 50.5877 24.8351 55.5685V59.7884C24.8351 64.7231 25.2271 69.1043 26.0111 72.9322C26.8412 76.7139 28.0634 79.9192 29.6775 82.548C31.3378 85.1767 33.367 87.1598 35.7652 88.4973C38.2095 89.8347 41.0458 90.5034 44.2741 90.5034C47.3641 90.5034 50.1082 89.8347 52.5063 88.4973C54.9045 87.1598 56.9107 85.1767 58.5248 82.548C60.1851 79.9192 61.4303 76.7139 62.2604 72.9322C63.1367 69.1043 63.5748 64.7231 63.5748 59.7884Z"
              fill="url(#paint2_linear_5100_344724)"
              test-id="LZdPkTOd"
            />

            <path
              d="M83.9953 80.2088L83.9967 80.2046C86.1197 74.197 87.1903 67.3959 87.1903 59.7884V55.7068C87.1903 48.0993 86.1197 41.2982 83.9967 35.2906C81.8689 29.2694 78.8906 24.1795 75.0724 20.0019L75.0687 19.9979C71.2485 15.7731 66.7133 12.5625 61.4545 10.3601L61.4448 10.3561L61.4448 10.356C56.2346 8.11023 50.4696 6.97975 44.1358 6.97975C37.7549 6.97975 31.9427 8.11056 26.6855 10.3572L26.6816 10.3589C21.4689 12.5608 16.9557 15.7713 13.134 19.9975L83.9953 80.2088ZM83.9953 80.2088C81.914 86.1811 78.9591 91.2711 75.1394 95.4957M83.9953 80.2088L75.1394 95.4957M75.1394 95.4957C71.3175 99.6767 66.8024 102.889 61.5861 105.138C56.3752 107.338 50.6091 108.446 44.2741 108.446C37.8927 108.446 32.0798 107.338 26.8222 105.137C21.6063 102.888 17.0677 99.6755 13.1992 95.4933C9.37997 91.2686 6.4025 86.1786 4.27559 80.2067C2.19805 74.1981 1.15047 67.3963 1.15047 59.7884V55.7068C1.15047 48.0985 2.19818 41.2963 4.27596 35.2874C6.40443 29.2654 9.36066 24.1752 13.1336 19.9979L75.1394 95.4957ZM25.0221 42.2102L25.0221 42.2102L25.0202 42.2192C24.2188 46.0847 23.8231 50.5374 23.8231 55.5685V59.7884C23.8231 64.7744 24.219 69.2258 25.0197 73.1353L25.0211 73.1422L25.0227 73.1492C25.8711 77.0144 27.1289 80.3313 28.8152 83.0775L28.8151 83.0775L28.8219 83.0883C30.5604 85.8409 32.7078 87.9509 35.2723 89.3811L35.2795 89.385C37.8948 90.8161 40.9032 91.5154 44.2741 91.5154C47.5146 91.5154 50.4323 90.8127 52.9992 89.3811C55.5652 87.9501 57.691 85.8382 59.3839 83.0828C61.1177 80.3359 62.3991 77.0184 63.2479 73.1535C64.1441 69.2366 64.5868 64.7787 64.5868 59.7884V55.5685C64.5868 50.5343 64.1445 46.076 63.248 42.2034C62.3989 38.2913 61.116 34.9683 59.3761 32.2617C57.6345 29.5526 55.4611 27.4899 52.8509 26.1085C50.2863 24.6807 47.3721 23.9798 44.1358 23.9798C40.7682 23.9798 37.7816 24.6777 35.2097 26.1104C32.642 27.4946 30.514 29.5611 28.8194 32.2725C27.1286 34.9779 25.8703 38.2993 25.0221 42.2102Z"
              stroke="url(#paint3_linear_5100_344724)"
              strokeOpacity="0.31"
              strokeWidth="2.02395"
              test-id="LG6zNTZ8"
            />

            <path
              d="M96.7803 71.4102V69.9575C96.7803 64.4693 97.5644 59.4193 99.1324 54.8075C100.7 50.1495 103.006 46.1141 106.05 42.7013C109.094 39.2885 112.853 36.6367 117.326 34.7458C121.8 32.8088 126.965 31.8403 132.822 31.8403C138.725 31.8403 143.914 32.8088 148.387 34.7458C152.907 36.6367 156.689 39.2885 159.732 42.7013C162.776 46.1141 165.082 50.1495 166.65 54.8075C168.218 59.4193 169.002 64.4693 169.002 69.9575V71.4102C169.002 76.8522 168.218 81.9022 166.65 86.5602C165.082 91.1721 162.776 95.2075 159.732 98.6664C156.689 102.079 152.93 104.731 148.456 106.622C143.983 108.513 138.818 109.458 132.96 109.458C127.103 109.458 121.915 108.513 117.395 106.622C112.876 104.731 109.094 102.079 106.05 98.6664C103.006 95.2075 100.7 91.1721 99.1324 86.5602C97.5644 81.9022 96.7803 76.8522 96.7803 71.4102ZM120.093 69.9575V71.4102C120.093 74.2235 120.301 76.8522 120.716 79.2965C121.131 81.7408 121.823 83.8853 122.791 85.7301C123.76 87.5287 125.074 88.9353 126.734 89.95C128.395 90.9646 130.47 91.4719 132.96 91.4719C135.405 91.4719 137.434 90.9646 139.048 89.95C140.708 88.9353 142.023 87.5287 142.991 85.7301C143.96 83.8853 144.652 81.7408 145.067 79.2965C145.482 76.8522 145.689 74.2235 145.689 71.4102V69.9575C145.689 67.2365 145.482 64.6769 145.067 62.2787C144.652 59.8344 143.96 57.6899 142.991 55.8451C142.023 53.9543 140.708 52.4785 139.048 51.4177C137.388 50.357 135.313 49.8266 132.822 49.8266C130.378 49.8266 128.326 50.357 126.665 51.4177C125.051 52.4785 123.76 53.9543 122.791 55.8451C121.823 57.6899 121.131 59.8344 120.716 62.2787C120.301 64.6769 120.093 67.2365 120.093 69.9575Z"
              fill="url(#paint4_linear_5100_344724)"
              test-id="82RUnhkK"
            />

            <path
              d="M121.895 86.2005L121.895 86.2005C120.869 84.2454 120.148 81.9959 119.718 79.4659C119.293 76.9588 119.081 74.2728 119.081 71.4102V69.9575C119.081 67.186 119.293 64.5689 119.718 62.108C120.148 59.5805 120.868 57.333 121.893 55.3793C122.933 53.3507 124.336 51.7374 126.11 50.572L126.12 50.5649L126.12 50.565C127.979 49.3778 130.231 48.8147 132.822 48.8147C135.455 48.8147 137.732 49.376 139.593 50.565C141.415 51.7289 142.846 53.3437 143.89 55.3791C144.915 57.3327 145.635 59.5803 146.064 62.1077C146.064 62.1082 146.064 62.1088 146.064 62.1093L145.067 62.2787C145.482 64.6769 145.689 67.2365 145.689 69.9575V71.4102C145.689 74.2235 145.482 76.8522 145.067 79.2965C144.652 81.7408 143.96 83.8853 142.991 85.7301L121.895 86.2005ZM121.895 86.2005L121.9 86.2099C122.949 88.1581 124.386 89.7006 126.207 90.8135C128.065 91.9489 130.335 92.4839 132.96 92.4839C135.54 92.4839 137.767 91.9488 139.581 90.8102L121.895 86.2005ZM100.091 55.1332L100.091 55.1303C101.619 50.592 103.859 46.6783 106.805 43.3749C109.743 40.0809 113.376 37.5142 117.72 35.6779L117.72 35.678L117.728 35.6745C122.052 33.8024 127.076 32.8523 132.822 32.8523C138.616 32.8523 143.662 33.8028 147.985 35.6745L147.985 35.6745L147.997 35.6794C152.387 37.5162 156.041 40.0828 158.977 43.3749C161.923 46.6783 164.163 50.592 165.691 55.1303L165.692 55.1332C167.22 59.6278 167.99 64.5663 167.99 69.9575V71.4102C167.99 76.7541 167.221 81.6939 165.691 86.2373C164.164 90.7278 161.924 94.6432 158.975 97.995C156.038 101.288 152.406 103.854 148.062 105.69C143.736 107.518 138.709 108.446 132.96 108.446C127.212 108.446 122.16 107.518 117.786 105.688C113.397 103.852 109.743 101.286 106.807 97.9951C103.858 94.6429 101.618 90.7271 100.091 86.236C98.5619 81.6929 97.7923 76.7536 97.7923 71.4102V69.9575C97.7923 64.5663 98.5623 59.6278 100.091 55.1332Z"
              stroke="url(#paint5_linear_5100_344724)"
              strokeOpacity="0.31"
              strokeWidth="2.02395"
              test-id="zfVAgW7C"
            />

            <path
              d="M298.435 87.0445C298.435 85.7532 297.996 84.6463 297.12 83.7239C296.29 82.7554 294.814 81.8792 292.693 81.0952C290.571 80.265 287.597 79.4349 283.769 78.6047C280.125 77.8207 276.69 76.7831 273.461 75.4917C270.279 74.2004 267.489 72.6324 265.091 70.7876C262.693 68.9429 260.802 66.7522 259.418 64.2157C258.081 61.6792 257.412 58.7737 257.412 55.4993C257.412 52.3171 258.081 49.3193 259.418 46.5061C260.802 43.6467 262.808 41.1333 265.437 38.9657C268.112 36.752 271.363 35.0225 275.191 33.7773C279.019 32.486 283.377 31.8403 288.265 31.8403C294.999 31.8403 300.81 32.878 305.698 34.9533C310.587 36.9826 314.346 39.8419 316.974 43.5314C319.649 47.1748 320.987 51.3947 320.987 56.191H297.674C297.674 54.3002 297.351 52.686 296.705 51.3486C296.106 50.0111 295.114 48.9965 293.73 48.3047C292.347 47.5668 290.502 47.1979 288.196 47.1979C286.582 47.1979 285.106 47.4976 283.769 48.0972C282.478 48.6967 281.44 49.5269 280.656 50.5876C279.872 51.6483 279.48 52.8935 279.48 54.3232C279.48 55.3378 279.71 56.2602 280.172 57.0903C280.679 57.8744 281.44 58.6123 282.454 59.304C283.469 59.9497 284.76 60.5493 286.328 61.1027C287.896 61.61 289.787 62.0712 292.001 62.4862C297.028 63.4086 301.732 64.723 306.113 66.4294C310.495 68.1358 314.046 70.557 316.767 73.6931C319.534 76.8292 320.917 81.049 320.917 86.3527C320.917 89.6732 320.157 92.7401 318.635 95.5534C317.113 98.3205 314.922 100.765 312.063 102.886C309.203 104.962 305.767 106.576 301.755 107.729C297.743 108.882 293.223 109.458 288.196 109.458C281.048 109.458 275.006 108.19 270.072 105.653C265.137 103.071 261.401 99.8424 258.865 95.9685C256.374 92.0484 255.129 88.0821 255.129 84.0698H276.851C276.943 86.3758 277.497 88.2666 278.511 89.7424C279.572 91.2182 280.979 92.302 282.731 92.9938C284.484 93.6856 286.513 94.0315 288.819 94.0315C290.94 94.0315 292.693 93.7317 294.076 93.1322C295.506 92.5326 296.59 91.7255 297.328 90.7109C298.066 89.6502 298.435 88.428 298.435 87.0445Z"
              fill="url(#paint6_linear_5100_344724)"
              test-id="S4UNa9QI"
            />

            <path
              d="M283.983 77.6158L283.982 77.6154C280.391 76.8427 277.01 75.8213 273.839 74.553C270.731 73.2916 268.024 71.7672 265.708 69.9855C263.418 68.224 261.623 66.1419 260.31 63.7374C259.062 61.3673 258.424 58.63 258.424 55.4993C258.424 52.4652 259.06 49.6173 260.331 46.9437C261.646 44.2263 263.557 41.8273 266.08 39.7465L266.082 39.7453C268.644 37.6248 271.778 35.9516 275.504 34.7397L275.504 34.7397L275.514 34.7362C279.219 33.4865 283.464 32.8523 288.265 32.8523C294.898 32.8523 300.568 33.8748 305.303 35.8849L305.303 35.8849L305.31 35.888C310.054 37.857 313.649 40.608 316.15 44.1187L316.154 44.1245L316.159 44.1303C318.51 47.3327 319.779 51.0052 319.954 55.1791H298.655C298.557 53.5922 298.221 52.1663 297.623 50.9214C296.923 49.3689 295.764 48.1933 294.195 47.4055C292.614 46.5657 290.59 46.1859 288.196 46.1859C286.454 46.1859 284.835 46.5102 283.355 47.1738L283.355 47.1737L283.343 47.1793C281.91 47.8444 280.735 48.7784 279.842 49.9861C278.918 51.2358 278.468 52.6962 278.468 54.3232C278.468 55.4977 278.737 56.5911 279.287 57.5818L279.303 57.6115L279.322 57.6401C279.922 58.5668 280.792 59.3952 281.884 60.1402L281.898 60.1492L281.911 60.1578C283.01 60.857 284.377 61.4869 285.992 62.057L286.004 62.0614L286.017 62.0655C287.638 62.5899 289.573 63.0605 291.815 63.4809L291.818 63.4816C296.788 64.3934 301.429 65.6912 305.746 67.3724C309.995 69.0271 313.403 71.36 316.002 74.3563L316.002 74.3563L316.008 74.3626C318.572 77.2684 319.906 81.2274 319.906 86.3527C319.906 89.5104 319.184 92.4098 317.746 95.0685C316.304 97.6904 314.218 100.026 311.464 102.071C308.716 104.064 305.393 105.631 301.476 106.756C297.57 107.878 293.147 108.446 288.196 108.446C281.165 108.446 275.293 107.199 270.537 104.755C265.729 102.238 262.139 99.1194 259.715 95.4199C257.528 91.9747 256.36 88.5322 256.169 85.0818H275.907C276.107 87.1105 276.683 88.8694 277.677 90.3157L277.683 90.3245L277.69 90.333C278.868 91.9725 280.433 93.1748 282.36 93.9351C284.254 94.6827 286.413 95.0434 288.819 95.0434C291.024 95.0434 292.923 94.7336 294.473 94.0631C296.031 93.409 297.278 92.5006 298.146 91.3061L298.152 91.2975L298.158 91.2888C299.023 90.0462 299.447 88.6193 299.447 87.0445C299.447 85.5067 298.918 84.1556 297.872 83.0456C296.872 81.891 295.211 80.948 293.052 80.1492C290.859 79.2916 287.827 78.4493 283.983 77.6158Z"
              stroke="url(#paint7_linear_5100_344724)"
              strokeOpacity="0.31"
              strokeWidth="2.02395"
              test-id="LS8lob8p"
            />

            <g opacity="0.5" test-id="mqeUaK6C">
              <path
                d="M347.874 100.465C347.874 97.1443 349.073 94.3772 351.471 92.1635C353.869 89.9037 356.959 88.7737 360.741 88.7737C364.569 88.7737 367.658 89.9037 370.011 92.1635C372.409 94.3772 373.608 97.1443 373.608 100.465C373.608 103.785 372.409 106.576 370.011 108.835C367.658 111.049 364.569 112.156 360.741 112.156C356.959 112.156 353.869 111.049 351.471 108.835C349.073 106.576 347.874 103.785 347.874 100.465ZM347.874 45.2607C347.874 41.9402 349.073 39.173 351.471 36.9593C353.869 34.6995 356.959 33.5696 360.741 33.5696C364.569 33.5696 367.658 34.6995 370.011 36.9593C372.409 39.173 373.608 41.9402 373.608 45.2607C373.608 48.5813 372.409 51.3714 370.011 53.6313C367.658 55.845 364.569 56.9518 360.741 56.9518C356.959 56.9518 353.869 55.845 351.471 53.6313C349.073 51.3714 347.874 48.5813 347.874 45.2607Z"
                fill="url(#paint8_linear_5100_344724)"
                test-id="MN1unSIB"
              />

              <path
                d="M390.695 72.3785V70.4415C390.695 60.895 391.663 52.2016 393.6 44.3614C395.583 36.4751 398.235 29.5573 401.556 23.608C404.876 17.6586 408.566 12.7239 412.624 8.80383C416.729 4.83762 420.926 2.00132 425.215 0.294922L429.573 11.7785C426.99 13.6694 424.477 16.252 422.032 19.5264C419.634 22.7548 417.467 26.744 415.53 31.4943C413.593 36.2445 412.048 41.8249 410.895 48.2354C409.788 54.6459 409.235 62.0018 409.235 70.3032V72.5169C409.235 80.8183 409.788 88.1742 410.895 94.5847C412.048 100.995 413.593 106.576 415.53 111.326C417.467 116.076 419.634 120.065 422.032 123.294C424.477 126.568 426.99 129.151 429.573 131.042L425.215 142.525C420.926 140.773 416.729 137.936 412.624 134.016C408.566 130.096 404.876 125.161 401.556 119.212C398.235 113.263 395.583 106.368 393.6 98.5279C391.663 90.6416 390.695 81.9251 390.695 72.3785Z"
                fill="url(#paint9_linear_5100_344724)"
                test-id="45wrF8n2"
              />
            </g>

            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M352.851 93.6436L352.844 93.6507C350.869 95.4737 349.897 97.698 349.897 100.465C349.897 103.229 350.868 105.483 352.851 107.355C354.816 109.165 357.386 110.132 360.741 110.132C364.155 110.132 366.715 109.158 368.623 107.362C370.612 105.488 371.584 103.232 371.584 100.465C371.584 97.698 370.613 95.4737 368.638 93.6507L368.623 93.637L368.608 93.623C366.698 91.7875 364.143 90.7977 360.741 90.7977C357.393 90.7977 354.826 91.783 352.859 93.6365L352.851 93.6436ZM370.011 108.835C367.658 111.049 364.569 112.156 360.741 112.156C356.959 112.156 353.869 111.049 351.471 108.835C349.073 106.576 347.874 103.785 347.874 100.465C347.874 97.1443 349.073 94.3772 351.471 92.1635C353.869 89.9037 356.959 88.7737 360.741 88.7737C364.569 88.7737 367.658 89.9037 370.011 92.1635C372.409 94.3772 373.608 97.1443 373.608 100.465C373.608 103.785 372.409 106.576 370.011 108.835ZM352.851 38.4395L352.844 38.4465C350.869 40.2696 349.897 42.4939 349.897 45.2607C349.897 48.025 350.868 50.2785 352.851 52.1511C354.816 53.9608 357.386 54.9279 360.741 54.9279C364.155 54.9279 366.715 53.9538 368.623 52.1574C370.612 50.2835 371.584 48.0281 371.584 45.2607C371.584 42.4939 370.613 40.2696 368.638 38.4465L368.623 38.4328L368.608 38.4188C366.698 36.5834 364.143 35.5936 360.741 35.5936C357.393 35.5936 354.826 36.5788 352.859 38.4323L352.851 38.4395ZM370.011 53.6313C367.658 55.845 364.569 56.9518 360.741 56.9518C356.959 56.9518 353.869 55.845 351.471 53.6313C349.073 51.3714 347.874 48.5813 347.874 45.2607C347.874 41.9402 349.073 39.173 351.471 36.9593C353.869 34.6995 356.959 33.5696 360.741 33.5696C364.569 33.5696 367.658 34.6995 370.011 36.9593C372.409 39.173 373.608 41.9402 373.608 45.2607C373.608 48.5813 372.409 51.3714 370.011 53.6313ZM422.032 19.5264C424.477 16.252 426.99 13.6694 429.573 11.7785L425.215 0.294922C424.594 0.541912 423.975 0.812577 423.358 1.10691C419.713 2.84607 416.135 5.41171 412.624 8.80383C408.566 12.7239 404.876 17.6586 401.556 23.608C398.235 29.5573 395.583 36.4751 393.6 44.3614C391.663 52.2016 390.695 60.895 390.695 70.4415V72.3785C390.695 81.9251 391.663 90.6416 393.6 98.5279C395.583 106.368 398.235 113.263 401.556 119.212C404.876 125.161 408.566 130.096 412.624 134.016C416.136 137.371 419.716 139.931 423.364 141.699C423.979 141.997 424.596 142.272 425.215 142.525L429.573 131.042C426.99 129.151 424.477 126.568 422.032 123.294C419.634 120.065 417.467 116.076 415.53 111.326C413.593 106.576 412.048 100.995 410.895 94.5847C409.788 88.1742 409.235 80.8183 409.235 72.5169V70.3032C409.235 62.0018 409.788 54.6459 410.895 48.2354C412.048 41.8249 413.593 36.2445 415.53 31.4943C417.467 26.744 419.634 22.7548 422.032 19.5264ZM427.149 131.723C424.812 129.811 422.568 127.395 420.411 124.504L420.408 124.501C417.885 121.104 415.64 116.957 413.656 112.09C411.653 107.179 410.074 101.457 408.903 94.943L408.902 94.936L408.9 94.9291C407.769 88.3788 407.211 80.9038 407.211 72.5169V70.3032C407.211 61.9163 407.769 54.4413 408.9 47.891L408.902 47.884L408.903 47.8771C410.074 41.3628 411.653 35.6406 413.656 30.73C415.64 25.8633 417.885 21.7158 420.408 18.3195L420.411 18.3157C422.568 15.425 424.812 13.0087 427.149 11.0968L424.079 3.00608C420.717 4.63315 417.366 7.03618 414.031 10.2593C410.141 14.0164 406.566 18.7837 403.323 24.5944C400.104 30.3613 397.512 37.1065 395.564 44.8513C393.673 52.5058 392.719 61.0316 392.719 70.4415V72.3785C392.719 81.7873 393.673 90.3365 395.564 98.0383C397.512 105.735 400.104 112.458 403.323 118.226C406.565 124.034 410.138 128.8 414.026 132.556C417.361 135.741 420.716 138.142 424.085 139.799L427.149 131.723Z"
              fill="url(#paint10_linear_5100_344724)"
              test-id="RTlNNKx4"
            />

            <defs test-id="F8XwA_mF">
              <linearGradient
                id="paint0_linear_5100_344724"
                x1="237.721"
                y1="133.852"
                x2="169.631"
                y2="62.6735"
                gradientUnits="userSpaceOnUse"
                test-id="baD3qiHG"
              >
                <stop
                  offset="0.133702"
                  stopColor="#CDCDCD"
                  stopOpacity="0.27"
                  test-id="X2EKNji7"
                />

                <stop
                  offset="0.758263"
                  stopColor="#6F6F6F"
                  stopOpacity="0.0252032"
                  test-id="kcEsnSDp"
                />

                <stop
                  offset="0.788828"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="ROncyDiT"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.17"
                  test-id="NlljqhZS"
                />
              </linearGradient>

              <linearGradient
                id="paint1_linear_5100_344724"
                x1="234.502"
                y1="-16.4896"
                x2="323.095"
                y2="61.2979"
                gradientUnits="userSpaceOnUse"
                test-id="x8bHiGq0"
              >
                <stop stopColor="#CDCDCD" test-id="fxHWpYkO" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="zkp8LWkB"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="JkU-7JWR"
                />
              </linearGradient>

              <linearGradient
                id="paint2_linear_5100_344724"
                x1="73.7346"
                y1="106.501"
                x2="9.47003"
                y2="19.8056"
                gradientUnits="userSpaceOnUse"
                test-id="q8A9fPOD"
              >
                <stop
                  offset="0.133702"
                  stopColor="#CDCDCD"
                  stopOpacity="0.27"
                  test-id="YYhh6Gm7"
                />

                <stop
                  offset="0.758263"
                  stopColor="#6F6F6F"
                  stopOpacity="0.0252032"
                  test-id="1cmLcKaE"
                />

                <stop
                  offset="0.788828"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="k_pYkthZ"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.17"
                  test-id="TulWYVct"
                />
              </linearGradient>

              <linearGradient
                id="paint3_linear_5100_344724"
                x1="69.6411"
                y1="-41.6562"
                x2="157.004"
                y2="57.3343"
                gradientUnits="userSpaceOnUse"
                test-id="O5csaBBV"
              >
                <stop stopColor="#CDCDCD" test-id="-r7BKbTF" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="wO8XFmLZ"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="0F0JTi_x"
                />
              </linearGradient>

              <linearGradient
                id="paint4_linear_5100_344724"
                x1="157.137"
                y1="107.241"
                x2="110.343"
                y2="38.2123"
                gradientUnits="userSpaceOnUse"
                test-id="cQa7c15F"
              >
                <stop
                  offset="0.133702"
                  stopColor="#CDCDCD"
                  stopOpacity="0.27"
                  test-id="cGTYYgcv"
                />

                <stop
                  offset="0.758263"
                  stopColor="#6F6F6F"
                  stopOpacity="0.0252032"
                  test-id="owBuZLIS"
                />

                <stop
                  offset="0.788828"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="hRaOJ23R"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.17"
                  test-id="8qD2h-aS"
                />
              </linearGradient>

              <linearGradient
                id="paint5_linear_5100_344724"
                x1="153.78"
                y1="-3.87761"
                x2="218.326"
                y2="76.0963"
                gradientUnits="userSpaceOnUse"
                test-id="tq_hSzDa"
              >
                <stop stopColor="#CDCDCD" test-id="6K-yHJle" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="U4Z84tdc"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="w9bv3MXJ"
                />
              </linearGradient>

              <linearGradient
                id="paint6_linear_5100_344724"
                x1="310.167"
                y1="107.241"
                x2="261.928"
                y2="42.3518"
                gradientUnits="userSpaceOnUse"
                test-id="0H2ryECt"
              >
                <stop
                  offset="0.133702"
                  stopColor="#CDCDCD"
                  stopOpacity="0.27"
                  test-id="JtZL64Mz"
                />

                <stop
                  offset="0.758263"
                  stopColor="#6F6F6F"
                  stopOpacity="0.0252032"
                  test-id="lyazcaYv"
                />

                <stop
                  offset="0.788828"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="-zgLqaIv"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.17"
                  test-id="mofA0LPX"
                />
              </linearGradient>

              <linearGradient
                id="paint7_linear_5100_344724"
                x1="307.106"
                y1="-3.87761"
                x2="372.651"
                y2="70.1776"
                gradientUnits="userSpaceOnUse"
                test-id="dftLgt2w"
              >
                <stop stopColor="#CDCDCD" test-id="O0RVmmaM" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="YleUIfPE"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="WUNOFyim"
                />
              </linearGradient>

              <linearGradient
                id="paint8_linear_5100_344724"
                x1="412.988"
                y1="-127.629"
                x2="564.673"
                y2="-32.8206"
                gradientUnits="userSpaceOnUse"
                test-id="gQca--q0"
              >
                <stop stopColor="#CDCDCD" test-id="QyCpJ9s6" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="_TCG1pO-"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="Pixcykms"
                />
              </linearGradient>

              <linearGradient
                id="paint9_linear_5100_344724"
                x1="412.988"
                y1="-127.629"
                x2="564.673"
                y2="-32.8206"
                gradientUnits="userSpaceOnUse"
                test-id="sJ-JSEUV"
              >
                <stop stopColor="#CDCDCD" test-id="Rxi_DMKL" />

                <stop
                  offset="0.763314"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="PKGit2Dy"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.771048"
                  test-id="Q9rf6hCm"
                />
              </linearGradient>

              <linearGradient
                id="paint10_linear_5100_344724"
                x1="339.509"
                y1="-36.3537"
                x2="469.684"
                y2="-7.9576"
                gradientUnits="userSpaceOnUse"
                test-id="PeDOoVWH"
              >
                <stop
                  stopColor="#CDCDCD"
                  stopOpacity="0.27"
                  test-id="i1G8AqTB"
                />

                <stop
                  offset="0.788828"
                  stopColor="#565656"
                  stopOpacity="0"
                  test-id="zU7Qz8L6"
                />

                <stop
                  offset="1"
                  stopColor="white"
                  stopOpacity="0.17"
                  test-id="gZCBcwic"
                />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <Stack className="text-center" test-id="NcWEe6nj">
          <Text className="text-sm text-c-gray-300" test-id="ZAfQxBzm">
            <span>
              This page is under maintenance.
              <br test-id="f1o262gH" /> Please{" "}
            </span>

            <LinkItem
              variant="ghost"
              className="text-white text-sm inline underline"
              isExternal
              slug="mailto:support@blink.global"
              test-id="fyfSPlcI"
            >
              contact support.
            </LinkItem>
          </Text>
        </Stack>
      </Stack>
    </div>
  );
};

export default ErrorBoundary;
